// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResults-cls1_ajb","cls2":"AutoCompleteResults-cls2_Wu8 AutoCompleteResults-cls1_ajb"};